import { render, staticRenderFns } from "./mode_switch.vue?vue&type=template&id=4ba9344b&scoped=true&"
import script from "./mode_switch.vue?vue&type=script&lang=js&"
export * from "./mode_switch.vue?vue&type=script&lang=js&"
import style0 from "./mode_switch.vue?vue&type=style&index=0&id=4ba9344b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba9344b",
  null
  
)

export default component.exports